import { render, staticRenderFns } from "./PubPageAdd.vue?vue&type=template&id=707048da&scoped=true&"
import script from "./PubPageAdd.vue?vue&type=script&lang=js&"
export * from "./PubPageAdd.vue?vue&type=script&lang=js&"
import style0 from "./PubPageAdd.vue?vue&type=style&index=0&id=707048da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707048da",
  null
  
)

export default component.exports